import { useTranslation } from "react-i18next";
import { useInView } from "@/hooks/useInView";

const thisSeason = [45, 55, 48, 62, 50, 72];
const lastSeason = [65, 78, 72, 85, 75, 92];

export function CostIntelligenceIllustration() {
  const { t } = useTranslation();
  const { ref, inView } = useInView();

  const months = [
    t("landing.illustrations.jan", "Jan"),
    t("landing.illustrations.mar", "Mar"),
    t("landing.illustrations.may", "May"),
    t("landing.illustrations.jul", "Jul"),
    t("landing.illustrations.sep", "Sep"),
    t("landing.illustrations.nov", "Nov"),
  ];

  return (
    <div ref={ref} className="rounded-2xl border border-landing-border bg-white p-6 shadow-soft">
      <div className="mb-4 flex items-baseline justify-between">
        <p className="text-sm font-semibold text-foreground">
          {t("landing.illustrations.costHaMonthly", "Cost / ha — Monthly")}
        </p>
        <span className="text-xs font-medium text-emerald-600">
          {t("landing.illustrations.vsLastSeason12", "-12% vs last season")}
        </span>
      </div>

      <div className="flex h-32 items-end gap-2">
        {months.map((_, i) => (
          <div key={i} className="flex flex-1 h-full items-end gap-0.5">
            <div
              className="flex-1 rounded-t-sm bg-red-400 transition-all duration-500"
              style={{
                height: inView ? `${lastSeason[i]}%` : "0%",
                transitionDelay: `${i * 0.06}s`,
              }}
            />
            <div
              className="flex-1 rounded-t-sm bg-emerald-500 transition-all duration-500"
              style={{
                height: inView ? `${thisSeason[i]}%` : "0%",
                transitionDelay: `${i * 0.06 + 0.05}s`,
              }}
            />
          </div>
        ))}
      </div>

      <div className="mt-2 flex justify-between text-[10px] text-muted-foreground">
        {months.map((m) => (
          <span key={m}>{m}</span>
        ))}
      </div>

      <div className="mt-3 flex items-center gap-4 text-[10px] text-muted-foreground">
        <span className="flex items-center gap-1">
          <span className="inline-block h-2 w-2 rounded-sm bg-red-400" />
          {t("landing.illustrations.lastSeason", "Last season")}
        </span>
        <span className="flex items-center gap-1">
          <span className="inline-block h-2 w-2 rounded-sm bg-emerald-500" />
          {t("landing.illustrations.thisSeason", "This season")}
        </span>
      </div>
    </div>
  );
}
